import { listViewStore } from 'owa-mail-list-store';
import { SuggestionKind } from 'owa-search-service';
export function getPersonaPillSuggestionsInSearchTable(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    if (tableView.tableQuery.type != 1 /* Search */) {
        throw new Error('getPersonaPillSuggestionsInSearchTable should not be called for non-search table');
    }
    var searchTableQuery = tableView.tableQuery;
    var personaSuggestions = searchTableQuery.pillSuggestions.filter(function (suggestion) {
        return suggestion.kind == SuggestionKind.People;
    });
    // Render persona/pdl header only if all the pills are of type people suggestion
    if (searchTableQuery.pillSuggestions.length === personaSuggestions.length) {
        return personaSuggestions;
    }
    return null;
}
//# sourceMappingURL=getPersonaPillSuggestionsInSearchTable.js.map